import { render, staticRenderFns } from "./PopularCompaniesWidget.vue?vue&type=template&id=2488dd14&scoped=true"
import script from "./PopularCompaniesWidget.vue?vue&type=script&lang=ts"
export * from "./PopularCompaniesWidget.vue?vue&type=script&lang=ts"
import style0 from "./PopularCompaniesWidget.vue?vue&type=style&index=0&id=2488dd14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2488dd14",
  null
  
)

export default component.exports